export const TURNSTILE_ACTIONS = {
  validateFile: 'validate_file',
  validateEndorsement: 'validate_endorsement'
} as const

export type TurnstileAction = typeof TURNSTILE_ACTIONS[keyof typeof TURNSTILE_ACTIONS]
